import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FavoriteLocationsModule } from '../../favorite-locations';
import { LocationModule } from '../../location';
import { FavoriteLocationsDialogComponent } from './favorite-locations-dialog.component';

@NgModule({
  imports: [CommonModule, FormsModule, MatProgressSpinnerModule, MatDialogModule, MatButtonModule, LocationModule, FavoriteLocationsModule],
  exports: [FavoriteLocationsDialogComponent],
  declarations: [FavoriteLocationsDialogComponent]
})
export class FavoriteLocationsDialogModule {}
